export default "__VITE_ASSET__347c3e49__"